export default {
  toasts: {
    table_selected: "Great, looks like your table is number: {{number}}",
  },
};
